export const sizeTypeAggregationFields = /* GraphQL */ `
  fragment sizeTypeAggregationFields on SizeTypeAggregation {
    name
    sizes {
      slug
      name
    }
  }
`
